<template>
    <nav>
      <ul>
        <li v-for="section in filteredSections" :key="section.id">
          <a 
            :href="'#' + section.id" 
            :class="{ active: activeSection === section.id }"
          >
            {{ section.name }}
          </a>
        </li>
      </ul>
    </nav>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeSection: null,
    };
  },
  computed: {
    filteredSections() {
      return this.sections.filter(s => s.enabled === true || typeof s.enabled === 'undefined')
    }
  },
  methods: {
    isElementFullyInView(element) {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top >= 0 && rect.bottom <= viewportHeight;
    },

    isElementPartiallyInView(element) {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top < viewportHeight && rect.bottom > 0;
    },

    updateActiveSection() {
      let fullyVisibleSection = null;
      let partiallyVisibleSection = null;

      this.sections.forEach((section) => {
        const element = document.getElementById(section.id);
        if (!element) return;

        if (this.isElementFullyInView(element)) {
          fullyVisibleSection = section.id;
        } else if (this.isElementPartiallyInView(element) && !fullyVisibleSection) {
          partiallyVisibleSection = section.id;
        }
      });

      this.activeSection = fullyVisibleSection || partiallyVisibleSection;
    }
  },
  mounted() {
    this.updateActiveSection();
    
    window.addEventListener('scroll', this.updateActiveSection);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveSection);
  },
};
</script>